import { render, staticRenderFns } from "./dealLoginPwd.vue?vue&type=template&id=e0544a04&"
import script from "./dealLoginPwd.vue?vue&type=script&lang=js&"
export * from "./dealLoginPwd.vue?vue&type=script&lang=js&"
import style0 from "./dealLoginPwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports